var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "logo-upload" }, [
    _vm.hasCustomLogo
      ? _c("div", { staticClass: "logo-preview" }, [
          _c("img", {
            attrs: {
              src: _vm.effectiveLogo,
              alt: _vm.$t("pages.settings.branding.logo.currentLogoAlt"),
            },
          }),
        ])
      : _c("div", { staticClass: "logo-placeholder" }, [
          _vm._v(
            " " +
              _vm._s(_vm.$t("pages.settings.branding.logo.noCustomLogo")) +
              " "
          ),
        ]),
    _c("input", {
      ref: "fileInput",
      staticClass: "hidden-input",
      attrs: { type: "file", accept: "image/png" },
      on: { change: _vm.onFileSelected },
    }),
    _c(
      "div",
      { staticClass: "actions" },
      [
        _c(
          "ib-button",
          { attrs: { loading: _vm.busy }, on: { click: _vm.onUploadClick } },
          [
            _vm._v(
              " " +
                _vm._s(_vm.$t("pages.settings.branding.logo.uploadButton")) +
                " "
            ),
          ]
        ),
        _vm.hasCustomLogo
          ? _c(
              "el-link",
              {
                attrs: {
                  type: "primary",
                  underline: false,
                  disabled: _vm.busy,
                },
                on: { click: _vm.onReset },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t("pages.settings.branding.logo.resetToDefault")
                    ) +
                    " "
                ),
              ]
            )
          : _vm._e(),
      ],
      1
    ),
    _vm.errorMessage
      ? _c("p", { staticClass: "error" }, [
          _vm._v(" " + _vm._s(_vm.errorMessage) + " "),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }